import { createCoreMethod } from '../../utils/createCoreMethod';
import { findNodeById } from '../../utils/findNodeById';
import { getAbsoluteCoordinates } from '../../utils/getAbsoluteCoordinates';
import { isNodeWithSize } from '../../utils/isNodeWithSize';

export const getFullNodeForNodeId = createCoreMethod(
  'getFullNodeForNodeId',
  async (nodeId: string, depth = 2) => {
    const fullNode = findNodeById(nodeId, figma.currentPage, depth);

    if (!fullNode) return null;

    if (isNodeWithSize(fullNode)) {
      const nodePosition = getAbsoluteCoordinates(fullNode);

      return {
        id: fullNode.id,
        name: fullNode.name,
        width: fullNode.width,
        height: fullNode.height,
        parent: fullNode.parent?.id,
        x: fullNode.x,
        y: fullNode.y,
        absoluteX: nodePosition.x,
        absoluteY: nodePosition.y,
      };
    }

    return { id: fullNode.id, name: fullNode.name };
  }
);
